import { http } from '@/core/api/';

const apiUrl = 'api/student';

export default {
  /*egressDate need DD/MMM/YYYY' format*/
  async studentSchool(sieId, egressDate) {
    return http.get(
      `${apiUrl}/egress/getstudentschool?studentSie=${sieId}&egressDate=${egressDate}`
    );
  },
};
